import axios from 'axios'
import Cookie from 'js-cookie'
import { getEnv, isWeixin, isInTH, getQueryString } from '@/utils'
import { COOKIE_KEY, AUTH_URL, COOKIE_KEY_PRXFIX } from '@/utils/constant'
import { wxLogin, jumpToAuthPath } from '@/utils/wx_login_utils'
import API_Data_Static from '@/config/staticInterfaceData'
import logUtil from '@/utils/log_util'
const env = getEnv()

const baseURLMap = {
  'local': 'https://ehcard-test.wecity.qq.com',
  'development': 'https://ehcard-test.wecity.qq.com',
  'pre': 'https://ehcard-test.wecity.qq.com',
  'experiment': 'https://ehcard-test.wecity.qq.com',
  'production': 'https://wechat.wecity.qq.com'
}

const baseURL = baseURLMap[env]

function getSessionId () {
  // 不出现 sessionId 为空的情况，后台处理
  return Cookie.get(COOKIE_KEY) || 'nosessionid'
}
// function getSessionId () {
//   if (env === 'local') {
//     // session会过期，过期后拿一个有效的session更新进来就好
//     return 'sz1579961438701A74D6324750FFBA5F30D92608F272D10THLoginTHT0'
//     // 意味不明的cookie-key
//     const sessionId = Cookie.get('p_thlogin_1_450_a33_sid')
//     return sessionId
//   } else if (window._msdk) {
//     return window._msdk.userInfo.sessionId
//   } else {
//     return 'sz1579961438701A74D6324750FFBA5F30D92608F272D10THLoginTHT0'
//   }
// }

/**
 * 需要兜底的无授权接口
 */
const CDNStaticWhiteList = [
  'getBaike',
  'getContents',
  'getChinaTotal',
  'getAreaInfo',
  'getForeignInfo'
]

/**
 * 请求遇到403或400时需自动跳转授权的函数
 */
const FUNCS_NEED_AUTH = [
  'PneumoniaSubscribeServer.getCityPlotSubs'
]

const httpUtils = async (func, req = {}, service = 'THPneumoniaService', context, headers) => {
  try {
    let res = await _httpUtils(func, req, service, context, headers)
    return res
  } catch (e) {
    // 单独做接口兜底策略
    if (~CDNStaticWhiteList.indexOf(func)) {
      // 该 API 在兜底白名单中
      // Step 1   TODO 使用 CDN 数据

      // Step 2 使用 本地数据
      if (API_Data_Static[func]) {
        return API_Data_Static[func]
      }
    }
    throw e
  }
}
const _httpUtils = (func, req = {}, service = 'THPneumoniaService', context = {}, headers) => {
  const config = {
    timeout: 10000,
    headers: {
      'businessid': 'tencent-health-h5',
      'sub-businessid': 'th-activity'
      // 'SessionID': getSessionId()
    }
  }
  const sessionId = getSessionId()
  if (sessionId) {
    config.headers.SessionId = sessionId
  }
  context.userId = logUtil.getUserId()
  context.channel = context.channel || getQueryString('channel') || undefined
  context = JSON.parse(JSON.stringify(context))
  const instance = axios.create({
    ...config,
    baseURL
  })

  let realService = service
  if ((!service || service === 'THPneumoniaService')) {
    realService = 'THPneumoniaOuterService'
  }

  const body = {
    args: { req },
    service: realService,
    func,
    context
  }

  // 自助排查，ligangtang的接口 args里必须有这个字段，否则400
  // 智能问答，温源的接口也要
  if (['Diagnosis_NCOVQAServer_NCOVQAServant', 'Diagnosis_DiagnosisPreServer_NCovDiagnosis'].includes(service)) {
    body.args.header = { requestId: Math.random().toFixed(16).substr(2) }
  }

  return instance.post(`api/${service}/${func}`, body, { headers })
    .then(res => res.data.args.rsp || JSON.parse(res.data.args.sRsp))
    .catch((e) => {
      // TODO 403 ，需要处理授权失效的问题, 也可以考虑直接抛出错误, 需要和业务确认
      if (e.response.status === 403) {
        // 授权失效
        // alert('授权异常，需要重新登录')
        if (isInTH()) {
          jumpToAuthPath()
        }
        if (FUNCS_NEED_AUTH.includes(`${service}.${func}`)) {
          jumpToAuthPath()
        }
        // throw new Error('Auth Failed')
      }
    })
}

export default httpUtils
